import { slashVisible, slashItems, slashProps, unsavedSubitems } from './stores';
import { get } from 'svelte/store'

export default {
  items: ({ query }) => {
    if (query.length < 3)
      return [];
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", "/p/news/items.hits?q="+query, false ); // false for synchronous request
    xmlHttp.send( null );
    var data = JSON.parse(xmlHttp.responseText)
    if (!('hits' in data))
      return [];
    return data['hits']['hits'].map(function(i) {
      return {
        title: i["_source"]["title"],
        command: ({ editor, range }) => {
          unsavedSubitems.set([...get(unsavedSubitems), {subitem_id: i["_id"], title: i["_source"]["title"], tag: null }])

          range.to = range.to + query.length + 1;

          editor.chain().focus().deleteRange(range)
            .insertContent(`<a class="pntr" href="/n/${i["_id"]}">${query}</a> `)
            .run();
        }

    }})
  },

  render: () => {
    return {
      onStart: (props) => {
        let editor = props.editor;
        let range = props.range;
        //let location = props.clientRect();
        //slashLocaltion.set({ x: location.x, y: location.y, height: location.height });
        slashProps.set({ editor, range });
      },

      onUpdate(props) {
        if (props.items.length)
          slashVisible.set(true);
        else
          slashVisible.set(false);
        slashItems.set(props.items);
      },

      onKeyDown(props) {

        if (props.event.key === 'Escape') {
          slashVisible.set(false);
          return true;
        } else
          if (props.event.key === 'ArrowUp') {
          slashProps.editor.chain().focus().deleteRange(range);
          //slashSelectedIndex.set( $slashSelectedIndex < slashItems.length ? $slashSelectedIndex+1 : slashItems.length - 1 );
        } else
          if (props.event.key === 'ArrowDown') {
            slashProps.editor.chain().focus().deleteRange(range);
          //slashSelectedIndex.set($slashSelectedIndex > 0 ? $slashSelectedIndex-1 : 0);
        }
      },

      onExit() {
        slashVisible.set(false);
      }
    };
  }
};

